import { render, staticRenderFns } from "./PopOver.vue?vue&type=template&id=187ace28"
import script from "./PopOver.vue?vue&type=script&lang=js"
export * from "./PopOver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports